import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import { IdSchemaType } from "../../../Configurator/Types/ConfiguratorTypes";
import IdMappingFacade from "../../../IdMapping/IdMappingFacade";
import MappingFactory from "../Factory/MappingFactory";
import MappingValidator from "../Validator/MappingValidator";

export default class MappingFacade {
  private validator: MappingValidator = null;
  private idMappingFacade: IdMappingFacade = null;
  private factory: MappingFactory = new MappingFactory();

  constructor(config: SDKConfigurationModel) {
    this.validator = new MappingValidator(config);
    this.idMappingFacade = new IdMappingFacade(config);
  }

  public getMappedFootballCountryIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    this.validator.validate(ids, inputProvider, outputProvider);
    const idsObject = {
      country: Array.from(ids),
    };
    const map = await this.idMappingFacade.getEntitiesByIdsMap(
      idsObject,
      inputProvider,
      outputProvider
    );

    return this.factory.remapToResponseModel(
      map,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballCompetitionIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    this.validator.validate(ids, inputProvider, outputProvider);
    const idsObject = {
      competition: Array.from(ids),
    };
    const map = await this.idMappingFacade.getEntitiesByIdsMap(
      idsObject,
      inputProvider,
      outputProvider
    );

    return this.factory.remapToResponseModel(
      map,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballTeamIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    this.validator.validate(ids, inputProvider, outputProvider);
    const idsObject = {
      team: Array.from(ids),
    };
    const map = await this.idMappingFacade.getEntitiesByIdsMap(
      idsObject,
      inputProvider,
      outputProvider
    );

    return this.factory.remapToResponseModel(
      map,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballPlayerIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    this.validator.validate(ids, inputProvider, outputProvider);
    const idsObject = {
      player: Array.from(ids),
    };
    const map = await this.idMappingFacade.getEntitiesByIdsMap(
      idsObject,
      inputProvider,
      outputProvider
    );

    return this.factory.remapToResponseModel(
      map,
      inputProvider,
      outputProvider
    );
  };

  public getFootballMappedMatchIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    this.validator.validate(ids, inputProvider, outputProvider);
    const idsObject = {
      match: Array.from(ids),
    };
    const map = await this.idMappingFacade.getEntitiesByIdsMap(
      idsObject,
      inputProvider,
      outputProvider
    );

    return this.factory.remapToResponseModel(
      map,
      inputProvider,
      outputProvider
    );
  };
}
